import LangEnum from '../../../lang/LangEnum';
import { FindTargetsPeriod } from '../../../services/modules/target/target.repository.types';
import { TargetPeriodType } from '../../../services/modules/target/target.types';
import { formatDateFromApi } from '../../../utils/dates';
import { useTranslation } from '../../translation/TranslationContext';
import { TARGET_DATE_FORMAT, TARGET_EMPTY_VALUE } from '../target.constants';
import { TargetDateRange } from '../target.types';
import { joinCollectionNames } from '../targetPeriod.utils';

const useTargetPeriodFormatter = () => {
  const { translate } = useTranslation();

  const formatDateRange = (range: TargetDateRange) => {
    const startDate = formatDateFromApi(range.startDate, TARGET_DATE_FORMAT);
    const endDate = formatDateFromApi(range.endDate, TARGET_DATE_FORMAT);

    if (!startDate || !endDate) {
      return TARGET_EMPTY_VALUE;
    }

    return translate(LangEnum.TARGET_LIST_PERIOD_RANGE, { startDate, endDate });
  };

  const formatPeriod = (period: FindTargetsPeriod | null) => {
    if (!period) {
      return TARGET_EMPTY_VALUE;
    }

    switch (period.type) {
      case TargetPeriodType.DATE_RANGE:
        return formatDateRange(period);
      case TargetPeriodType.ORDER_COLLECTION:
      case TargetPeriodType.PRODUCT_COLLECTION:
        return (
          joinCollectionNames((period.collections ?? []).map((collection) => collection.name)) ||
          TARGET_EMPTY_VALUE
        );
    }
  };

  return { formatPeriod, formatDateRange };
};

export default useTargetPeriodFormatter;
